var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4UnisexLocker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.62 50.28L40 36.13v-1.42c0-.46 0-.56 1.2-1.28a6.669 6.669 0 003.8-6.25 7 7 0 10-14-.12h4a3.07 3.07 0 014-2.94 3.1 3.1 0 012 3.06c0 1.67-.65 2-1.87 2.77-1.22.77-3.13 1.9-3.13 4.76v1.42L10.38 50.28a2 2 0 00.101 3.588 2 2 0 00.929.182h53.18a2 2 0 001.67-.77 2 2 0 00-.64-3zm-47-.22L38 39.87l19.53 10.19H18.62z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Unisex_locker.bd8e2239.svg";
export { SvgE4UnisexLocker as ReactComponent };